// ============================================================
// تعارف و احوال‌پرسی — جواب آنی، بدون مدل
//
// «سلام خوبی» یک رفت‌وبرگشت به مدل (۱.۵ ثانیه) و یک رفت‌وبرگشت برای
// صدا (۲ ثانیه) می‌خواست. برای یک سلام، چهار ثانیه سکوت یعنی «این
// چیز کند است» — حتی اگر بقیه‌ی کارها سریع باشند.
//
// این‌ها جواب‌هایی‌اند که هیچ‌وقت به مدل نیاز ندارند: صورت ثابتی
// دارند و هر مدلی هم همین‌ها را می‌گوید. آنی و رایگان.
//
// عمداً کوچک می‌ماند. هر چیزی که واقعاً جواب فکرشده می‌خواهد باید به
// مدل برود؛ این فهرست جای هوش را نمی‌گیرد، فقط تعارف را رد می‌کند.
// ============================================================

import { normalize } from "./text";

interface SmallTalk {
    /** جمله‌ی کاربر باید *عیناً* یکی از این‌ها باشد، نه شاملش */
    exact: string[];
    /** چند جواب، تا دستیار تکراری و ماشینی نشود */
    replies: string[];
}

const TABLE: SmallTalk[] = [
    {
        exact: [
            "سلام", "سلام علیکم", "درود", "های", "هی", "hi", "hello",
            "سلام دستیار", "سلام خوبی", "سلام خوبی؟", "سلام چطوری",
            "سلام حالت چطوره", "سلام وقت بخیر", "وقت بخیر", "صبح بخیر",
            "شب بخیر", "عصر بخیر",
        ],
        replies: [
            "سلام! در خدمتم. چه کمکی می‌تونم بکنم؟",
            "سلام، خوش آمدید. چی لازم دارید؟",
            "سلام! بفرمایید.",
        ],
    },
    {
        exact: [
            "خوبی", "خوبی؟", "چطوری", "چطوری؟", "حالت چطوره", "خوبی تو",
            "چه خبر", "چه خبر؟",
        ],
        replies: [
            "ممنون، خوبم. شما چطورید؟ چه کاری داشتید؟",
            "خوبم، مرسی که پرسیدید. در خدمتم.",
        ],
    },
    {
        exact: [
            "ممنون", "مرسی", "ممنونم", "متشکرم", "دستت درد نکنه",
            "دست شما درد نکنه", "عالی بود", "خوب بود", "لطف کردی",
            "تشکر", "thanks", "thank you",
        ],
        replies: [
            "خواهش می‌کنم. کار دیگری بود بگویید.",
            "قربان شما. هر وقت لازم داشتید در خدمتم.",
        ],
    },
    {
        exact: [
            "خداحافظ", "بای", "فعلا", "فعلاً", "خدافظ", "میبینمت",
            "تا بعد", "bye",
        ],
        replies: ["خداحافظ! هر وقت کاری داشتید همین‌جا هستم.", "فعلاً. موفق باشید."],
    },
    {
        exact: ["تو کی هستی", "شما کی هستی", "تو چی هستی", "اسمت چیه", "کی هستی"],
        replies: [
            "دستیار سامانه‌ی رصد توزیع آرد هستم. می‌توانم داده نشان بدهم، صفحه‌ها را فیلتر کنم، خروجی اکسل بگیرم و درباره‌ی خود سامانه جواب بدهم.",
        ],
    },
    {
        exact: ["اوکی", "باشه", "خب", "اوک", "ok", "okay", "بله", "آره", "اها", "آهان"],
        replies: ["بله، در خدمتم.", "خب، بفرمایید."],
    },
];

/**
 * جواب آنی برای تعارف؛ null یعنی «این جمله را به لایه‌های بعدی بسپار».
 *
 * تطبیق *دقیق* است و این مهم‌ترین تصمیم این فایل است: «سلام، سهمیه
 * علی حیدری رو بده» نباید با «سلام» جواب بگیرد و درخواست واقعی کاربر
 * گم شود.
 */
export const smallTalkReply = (message: string): string | null => {
    const asked = normalize(message).replace(/[؟?!.]+$/, "").trim();
    if (!asked || asked.length > 30) return null;

    for (let i = 0; i < TABLE.length; i++) {
        const entry = TABLE[i];
        for (let j = 0; j < entry.exact.length; j++) {
            if (asked === normalize(entry.exact[j])) {
                const replies = entry.replies;
                return replies[Math.floor(Math.random() * replies.length)];
            }
        }
    }

    return null;
};
